import React, { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import translate from '@translate';
import { styled } from '@mui/material/styles';
import { addMessage } from 'src/resources/alertMessages/reducer';

const TRUNCATE_LENGTH = 80;

const StyledCell = styled('span')({
    cursor: 'copy',
    display: 'inline-block',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
});

export interface TruncatedCopyCellPropsType {
    value?: string | number | null;
    maxLength?: number;
    'data-testid'?: string;
}

const TruncatedCopyCell: FC<TruncatedCopyCellPropsType> = (props) => {
    const dispatch = useDispatch();
    const text = props.value === null || props.value === undefined ? '' : String(props.value);
    const maxLength = props.maxLength ?? TRUNCATE_LENGTH;
    const displayText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    const handleDoubleClick = useCallback(async () => {
        if (!text) {
            return;
        }
        try {
            await navigator.clipboard.writeText(text);
            dispatch(
                addMessage({
                    type: 'success',
                    title: translate('messages.copiedToClipboard'),
                })
            );
        } catch {
            dispatch(
                addMessage({
                    type: 'error',
                    title: translate('messages.copyFailed'),
                })
            );
        }
    }, [dispatch, text]);

    if (!text) {
        return null;
    }

    return (
        <StyledCell
            title={text}
            onDoubleClick={handleDoubleClick}
            data-testid={props['data-testid']}
            aria-label={translate('webhookRecords.action.copyOnDoubleClick')}
        >
            {displayText}
        </StyledCell>
    );
};

export default TruncatedCopyCell;
